import { render, staticRenderFns } from "./AccountGoogle.vue?vue&type=template&id=7719cdd1&scoped=true"
import script from "./AccountGoogle.vue?vue&type=script&lang=js"
export * from "./AccountGoogle.vue?vue&type=script&lang=js"
import style0 from "./AccountGoogle.vue?vue&type=style&index=0&id=7719cdd1&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7719cdd1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/nodejs-standardization-global-v2.0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7719cdd1')) {
      api.createRecord('7719cdd1', component.options)
    } else {
      api.reload('7719cdd1', component.options)
    }
    module.hot.accept("./AccountGoogle.vue?vue&type=template&id=7719cdd1&scoped=true", function () {
      api.rerender('7719cdd1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page2/AccountGoogle.vue"
export default component.exports